import { IconComponent } from './types';

const LineSegmentIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="1"
    viewBox="0 0 12 1"
    fill="none"
    {...props}
  >
    <path stroke="currentColor" strokeWidth={0.5} d="M.25.25h11.5v.5H.25z" />
  </svg>
);

export default LineSegmentIcon;
